export default "__VITE_ASSET__34f9e033__"